module.exports = __webpack_public_path__ + "static/media/logo-instagram.4d5ce74d.svg";